import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Essential',
  price: 'KES 4,999',
  period: '/year',
  description: 'Fundamental compliance for growing businesses.',
  features: ['Single Store Integration', 'Real-time eTims Sync', 'Basic Reporting Dashboard', 'Email Support', 'Automatic Updates'],
  highlight: false
}, {
  name: 'Sovereign',
  price: 'KES 12,999',
  period: '/year',
  description: 'The complete suite for established enterprises.',
  features: ['Multi-Store Integration', 'Priority Real-time Sync', 'Advanced Analytics Suite', '24/7 Priority Concierge Support', 'Custom Reporting', 'Dedicated Account Manager'],
  highlight: true
}];
export function Pricing() {
  return <section className="py-32 bg-sovereign-navy text-white relative overflow-hidden" data-id="element-131">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5 bg-[linear-gradient(45deg,transparent_25%,rgba(212,175,55,0.1)_50%,transparent_75%,transparent_100%)] bg-[length:20px_20px]" data-id="element-132" />

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-133">
        <div className="text-center mb-24" data-id="element-134">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-4xl md:text-5xl font-serif mb-6 text-white" data-id="element-135">
            Investment
          </motion.h2>
          <p className="text-gray-400 max-w-xl mx-auto font-light" data-id="element-136">
            Transparent pricing for a priceless peace of mind. Choose the tier
            that befits your stature.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-137">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className={`relative p-10 md:p-14 flex flex-col ${tier.highlight ? 'bg-sovereign-navy-light border border-sovereign-gold' : 'bg-white/5 border border-white/10'}`} data-id="element-138">
              {tier.highlight && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-sovereign-gold text-sovereign-navy px-4 py-1 text-xs font-bold uppercase tracking-widest" data-id="element-139">
                  Most Popular
                </div>}

              <h3 className={`text-2xl font-serif mb-2 ${tier.highlight ? 'text-sovereign-gold' : 'text-white'}`} data-id="element-140">
                {tier.name}
              </h3>
              <div className="flex items-baseline mb-6" data-id="element-141">
                <span className="text-4xl font-light" data-id="element-142">{tier.price}</span>
                <span className="text-gray-400 ml-2 text-sm" data-id="element-143">
                  {tier.period}
                </span>
              </div>
              <p className="text-gray-400 mb-10 font-light border-b border-white/10 pb-8" data-id="element-144">
                {tier.description}
              </p>

              <ul className="space-y-4 mb-12 flex-1" data-id="element-145">
                {tier.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-146">
                    <Check className={`w-5 h-5 ${tier.highlight ? 'text-sovereign-gold' : 'text-gray-500'}`} data-id="element-147" />
                    <span className="text-gray-300 font-light" data-id="element-148">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={tier.highlight ? 'primary' : 'outline'} className="w-full" data-id="element-149">
                Select Plan
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}